// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Flex } from '@iheartjane/reefer';
import { mediaQueries } from '@iheartjane/reefer-emotion';
import type { PropsWithChildren } from 'react';

import { useSpecialDetailContext } from './SpecialDetail';

const SpecialDetailLayoutFlex = styled(Flex)<{
  disableAnimation: boolean;
  top: number;
}>(({ disableAnimation, top }) => ({
  flexDirection: 'column',
  width: '100%',
  position: disableAnimation ? 'static' : 'fixed',
  zIndex: disableAnimation ? 'unset' : 'var(--layers-header)',
  top: disableAnimation ? 'unset' : top,
  background: 'var(--colors-grays-white)',
  borderBottom: disableAnimation ? '1px solid rgba(0, 0, 0, 0.1)' : 'unset',
  gap: '32px',
  padding: '16px 48px',
  transform: ' translate3d(0, 0, 0)',
  backfaceVisibility: 'hidden',
  willChange: 'transition',
  transition: 'all 250ms',

  [mediaQueries.desktop('sm', 'min')]: {
    padding: '32px 64px',
  },

  '#special-detail-layout.scrolled-from-top &': {
    padding: '8px 24px 0',
    boxShadow: 'var(--shadows-hard)',

    [mediaQueries.desktop('sm', 'min')]: {
      padding: '16px 32px',
    },
  },
}));

export const SpecialDetailLayout = ({
  children,
  top,
}: PropsWithChildren<{ top: number }>) => {
  const { disableAnimation } = useSpecialDetailContext();

  return (
    <SpecialDetailLayoutFlex
      top={top}
      disableAnimation={!!disableAnimation}
      id="special-detail-layout-header"
    >
      {children}
    </SpecialDetailLayoutFlex>
  );
};
